import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@ngneat/dialog';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, IconComponent } from '@shared/components/ui';
import { FormErrorComponent } from '@shared/components';

@Component({
  selector: 'app-single-input-create',
  imports: [IconComponent, ButtonComponent, TranslateModule, FormsModule, ReactiveFormsModule, FormErrorComponent],
  templateUrl: './single-input-create.component.html',
  styleUrls: ['./single-input-create.component.scss'],
})
export class SingleInputCreateComponent {
  data:
    | {
        title: string;
        label: string;
        value?: any;
        inputType?: any;
      }
    | undefined = undefined;
  inputForm: FormGroup;
  private readonly _dialogRef = inject(DialogRef);

  constructor() {
    const _dialogRef = this._dialogRef;

    this.inputForm = new FormGroup({
      input: new FormControl(null, [Validators.required, Validators.maxLength(100), Validators.minLength(3)]),
    });
    this.data = _dialogRef.data;
    if (this.data?.value) {
      this.inputForm.patchValue({ input: this.data?.value || null });
    }
  }

  closeDialog(value?: 'save') {
    if (value === 'save' && this.inputForm.valid) {
      this._dialogRef.close(this.inputForm.value.input);
    } else {
      this._dialogRef.close();
    }
  }
}
